import axios from 'axios'
import { createUuidGenerator } from '@bhkk/fingerprint-generator'
import { getCookie } from "@/helper/dom";


  const api = axios.create({ timeout: 10000,  baseURL: '/getapi/' });
  //生成uuid的方法，开发环境下不会更新uuid。
  const uuidGenerator =  createUuidGenerator('production')
  api.interceptors.request.use(async config => {
    //生成指纹。生成出来的指纹会被存放到cookie里，由于异步生成，因此本次请求用到的指纹有可能是上一次请求生成的
    (await uuidGenerator)();
    const {target} = getCookie("bhFingerprint", undefined);
    config.headers.common["appId"] = 10;
    config.headers.common["Browser-Uuid"] = target;
    return config
  })
  api.interceptors.response.use(res =>res.data);




export default {
  install(Vue) {
    Vue.prototype.$api = api
  }
}